import { Skeleton } from '@mui/material';
import { SkeletonContainer } from './styles';

const RoundedEmailIcon = () => (
  <Skeleton
    variant='rounded'
    height='68px'
    width='68px'
    sx={{ borderRadius: '50%' }}
  />
);
const TitleHeader = () => (
  <Skeleton
    variant='text' sx={{ fontSize: '1rem', width: 200 }}
  />
);
const MessageBody = () => (
  <SkeletonContainer
    sx={{ mt: 2 }}>
    <Skeleton
      variant='text' sx={{ fontSize: '1rem', width: 350 }}
    />
    <Skeleton
      variant='text' sx={{ fontSize: '1rem', width: 300 }}
    />
    <Skeleton
      variant='text' sx={{ fontSize: '1rem', width: 350 }}
    />
  </SkeletonContainer>
);
const SkeletonLoader = () => {
  return (
    <SkeletonContainer>
      <RoundedEmailIcon />
      <TitleHeader />
      <MessageBody />
    </SkeletonContainer>
  );
};

export default SkeletonLoader;
